import { ComponentType } from 'react'
import { AboutNav } from 'views/common/about-nav'
import { Hero } from './hero'

export const WorkPolicy: ComponentType = () => (
  <>
    <Hero />
    <AboutNav />
  </>
)
